import React, { Component } from 'react';
import config from 'react-global-configuration';

import { Modal } from 'react-bootstrap';

import InputMask from 'react-input-mask';
import Select from 'react-select';
import getLocale from '../../../i18n/getLocale';
class AirportOperatorsPpmAdd extends Component {

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      modal_duplicate: false,
      modal_edit: false,
      loaded: 0,
      id: this.props.id,
      currencies_select: this.props.currencies_select,
      active: 0,
      domestic_flight: null,
      pmd_from: null,
      pmd_to: null,
      date_start: null,
      date_finish: null,
      value: null,
      data: [],
    };
    //Handlers
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.locale = getLocale();
    this.add = this.add.bind(this);
    this.duplicate = this.duplicate.bind(this);
    this.edit = this.edit.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentWillReceiveProps(newProps) {
    if(typeof newProps.id !== "undefined" && (this.state.loaded === 0)) {
      this.setState({id: newProps.id, currencies_select: newProps.currencies_select});
    }
    if(Array.isArray(newProps.data) && (this.state.loaded === 0)) {
      this.setState({data: newProps.data, loaded: 1});
    }
  }
  

  // Fetch salvando a edição
  add(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      airport_operator_id: this.state.id,
      domestic_flight: this.state.domestic_flight,
      group: this.state.group,
      pmd_from: this.state.pmd_from,
      pmd_to: this.state.pmd_to,
      date_start: this.state.date_start,
      date_finish: this.state.date_finish,
      currency_id: this.state.currency_id,
      value: this.state.value,
    };
    var header = this.props.RequestApi.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/operador/ppm', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.props.RequestApi.validate(responseJson, 'alert');
        if(responseJson.status === 'success') {
          self.setState({ data: responseJson.data });
        }
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  duplicate(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      airport_operator_id: this.state.id,
      domestic_flight: this.state.duplicate_domestic_flight,
      group: this.state.duplicate_group,
      pmd_from: this.state.duplicate_pmd_from,
      pmd_to: this.state.duplicate_pmd_to,
      date_start: this.state.duplicate_date_start,
      date_finish: this.state.duplicate_date_finish,
      currency_id: this.state.duplicate_currency_id,
      value: this.state.duplicate_value,
    };
    var header = this.props.RequestApi.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/operador/ppm', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.props.RequestApi.validate(responseJson, 'alert');
        if(responseJson.status === 'success') {
          self.setState({ data: responseJson.data });
        }
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  edit(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.edit_id,
      airport_operator_id: this.state.id,
      domestic_flight: this.state.edit_domestic_flight,
      group: this.state.edit_group,
      pmd_from: this.state.edit_pmd_from,
      pmd_to: this.state.edit_pmd_to,
      date_start: this.state.edit_date_start,
      date_finish: this.state.edit_date_finish,
      currency_id: this.state.edit_currency_id,
      value: this.state.edit_value,
    };
    var header = this.props.RequestApi.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/operador/ppm', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.props.RequestApi.validate(responseJson, 'alert');
        if(responseJson.status === 'success') {
          self.setState({ data: responseJson.data });
        }
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  showModalDuplicate (airport_operator_landing, event) {
    this.setState({ 
      duplicate_domestic_flight: airport_operator_landing.domestic_flight,
      duplicate_date_start: airport_operator_landing.validity_start_date_str,
      duplicate_date_finish: airport_operator_landing.validity_end_date_str,
      duplicate_group: airport_operator_landing.group,
      duplicate_pmd_from: airport_operator_landing.pmd_from,
      duplicate_pmd_to: airport_operator_landing.pmd_to,
      duplicate_currency_id: airport_operator_landing.currency_id,
      duplicate_value: airport_operator_landing.value_str,
      modal_duplicate: true,
    });
  }
  showModalEdit (airport_operator_landing, event) {
    this.setState({ 
      edit_id: airport_operator_landing.id,
      edit_domestic_flight: airport_operator_landing.domestic_flight,
      edit_date_start: airport_operator_landing.validity_start_date_str,
      edit_date_finish: airport_operator_landing.validity_end_date_str,
      edit_group: airport_operator_landing.group,
      edit_pmd_from: airport_operator_landing.pmd_from,
      edit_pmd_to: airport_operator_landing.pmd_to,
      edit_currency_id: airport_operator_landing.currency_id,
      edit_value: airport_operator_landing.value_str,
      modal_edit: true,
    });
  }

  render() {
    var self = this;
    return (
<div>
    <h3>{this.locale.OperadoresAeroporto.EditarOperadoresAeroporto.tabelaPpm.titulo}</h3>
    <hr />
    <form onSubmit={this.add}>
      <div className="row">
          <div className="col-md-6 form-group">
          <label>{this.locale.OperadoresAeroporto.EditarOperadoresAeroporto.tabelaPpm.formulario.NaturezaDoVoo}:</label>
          <Select
              className="form-field-name"
              name="domestic_flight"
              value={this.state.domestic_flight}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'domestic_flight')}
              options={[
              {value: '1', label: this.locale.OperadoresAeroporto.EditarOperadoresAeroporto.tabelaPpm.formulario.OpcoesNaturezaDoVoo.Domestico},
              {value: '0', label: this.locale.OperadoresAeroporto.EditarOperadoresAeroporto.tabelaPpm.formulario.OpcoesNaturezaDoVoo.Internacional},
              ]}
          />
          </div>
          <div className="col-md-6 form-group">
          <label>{this.locale.OperadoresAeroporto.EditarOperadoresAeroporto.tabelaPpm.formulario.Grupo}:</label>
          <Select
              className="form-field-name"
              name="group"
              value={this.state.group}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'group')}
              options={[
              {value: '1', label: '1'},
              {value: '2', label: '2'},
              {value: '3', label: '3'},
              ]}
          />
          </div>
      </div>
      <div className="row">
          <div className="col-md-6 form-group">
          <label>{this.locale.OperadoresAeroporto.EditarOperadoresAeroporto.tabelaPpm.formulario.PmdDe}:</label>
          <input type="text" placeholder="" className="form-control" name="pmd_from" value={this.state.pmd_from} onChange={this.handleChange.bind(this, 'pmd_from')} />
          </div>
          <div className="col-md-6 form-group">
          <label>{this.locale.OperadoresAeroporto.EditarOperadoresAeroporto.tabelaPpm.formulario.PmdAte}:</label>
          <input type="text" placeholder="" className="form-control" name="pmd_to" value={this.state.pmd_to} onChange={this.handleChange.bind(this, 'pmd_to')} />
          </div>
      </div>
      <div className="row">
          <div className="col-md-6 form-group">
          <label>{this.locale.OperadoresAeroporto.EditarOperadoresAeroporto.tabelaPpm.formulario.DataDeInicioDeVigencia}:</label>
          <InputMask value={this.state.date_start}  maskChar={null} name="date_start " mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder="" required />
          </div>
          <div className="col-md-6 form-group">
          <label>{this.locale.OperadoresAeroporto.EditarOperadoresAeroporto.tabelaPpm.formulario.DataDeTerminoDeVigencia}:</label>
          <InputMask value={this.state.date_finish}  maskChar={null} name="date_finish " mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_finish')} placeholder="" required />
          </div>
      </div>
      <div className="row">
          <div className="col-md-6 form-group">
            <label>{this.locale.OperadoresAeroporto.EditarOperadoresAeroporto.tabelaPpm.formulario.Moeda}:</label>
            <Select
              className="form-field-name"
              name="currency_id"
              value={this.state.currency_id}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'currency_id')}
              options={this.state.currencies_select}
            />
          </div>
          <div className="col-md-6 form-group">
            <label>{this.locale.OperadoresAeroporto.EditarOperadoresAeroporto.tabelaPpm.formulario.Valor}:</label>
            <input type="text" placeholder="Valor" className="form-control" name="value" value={this.state.value} onChange={this.handleChange.bind(this, 'value')} />
          </div>
      </div>
      <div>
          <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.OperadoresAeroporto.EditarOperadoresAeroporto.tabelaPpm.formulario.botaoAdicionarPpm}</button>
      </div>
    </form>
    <hr />
    <div className="table-responsive">
      <table className="table table-bordered table-hover table-striped">
          <thead>
          <tr>
              <th>{this.locale.OperadoresAeroporto.EditarOperadoresAeroporto.tabelaPpm.tabela.NaturezaDoVoo}</th>
              <th>{this.locale.OperadoresAeroporto.EditarOperadoresAeroporto.tabelaPpm.tabela.PmdDe}</th>
              <th>{this.locale.OperadoresAeroporto.EditarOperadoresAeroporto.tabelaPpm.tabela.PmdAte}</th>
              <th>{this.locale.OperadoresAeroporto.EditarOperadoresAeroporto.tabelaPpm.tabela.Grupo}</th>
              <th>{this.locale.OperadoresAeroporto.EditarOperadoresAeroporto.tabelaPpm.tabela.Moeda}</th>
              <th>{this.locale.OperadoresAeroporto.EditarOperadoresAeroporto.tabelaPpm.tabela.Valor}</th>
              <th>{this.locale.OperadoresAeroporto.EditarOperadoresAeroporto.tabelaPpm.tabela.DataInicioVigencia}</th>
              <th>{this.locale.OperadoresAeroporto.EditarOperadoresAeroporto.tabelaPpm.tabela.DataTerminoVigencia}</th>
              <th>{this.locale.OperadoresAeroporto.EditarOperadoresAeroporto.tabelaPpm.tabela.Acoes}</th>
          </tr>
          </thead>
          <tbody id="dates">
          {Object.keys(self.state.data).map(function(k) {
          var airport_operator_landing = self.state.data[k];
          return (
              <tr>
              <td>{airport_operator_landing.domestic_flight_str}</td>
              <td>{airport_operator_landing.pmd_from_str}</td>
              <td>{airport_operator_landing.pmd_to_str}</td>
              <td>{airport_operator_landing.group}</td>
              <td>{airport_operator_landing.currency.alphabetical_code}</td>
              <td>{airport_operator_landing.value_str}</td>
              <td>{airport_operator_landing.validity_start_date_str}</td>
              <td>{airport_operator_landing.validity_end_date_str}</td>
              <td className="text-center">

                  <button onClick={self.showModalDuplicate.bind(self, airport_operator_landing)} className="btn btn-warning btn-sm"><i className="fa fa-refresh"></i></button>
                  <button onClick={self.showModalEdit.bind(self, airport_operator_landing)} className="btn btn-primary btn-sm"><i className="fa fa-pencil"></i></button>
                
              </td>
              </tr>
          );
          })}
          </tbody>
      </table>
    </div>
    <Modal show={this.state.modal_duplicate} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
      <Modal.Header>
        <h4 className="pull-left">{this.locale.OperadoresAeroporto.EditarOperadoresAeroporto.tabelaPpm.modalDuplicarPpm.titulo}</h4>
        <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal_duplicate: false })}>
        <i className="fa fa-fw fa-close"></i></button>
        <div className="clearfix"></div>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={this.duplicate}>
          <div className="row">
            <div className="col-md-3 form-group">
              <label>{this.locale.OperadoresAeroporto.EditarOperadoresAeroporto.tabelaPpm.modalDuplicarPpm.formulario.DataDeInicioDeVigencia}:</label>
              <InputMask value={this.state.duplicate_date_start}  maskChar={null} name="duplicate_date_start " mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'duplicate_date_start')} placeholder="" required />
            </div>
            <div className="col-md-3 form-group">
              <label>{this.locale.OperadoresAeroporto.EditarOperadoresAeroporto.tabelaPpm.modalDuplicarPpm.formulario.DataDeTerminoDeVigencia}:</label>
              <InputMask value={this.state.duplicate_date_finish}  maskChar={null} name="duplicate_date_finish " mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'duplicate_date_finish')} placeholder="" required />
            </div>
            <div className="col-md-3 form-group">
              <label>{this.locale.OperadoresAeroporto.EditarOperadoresAeroporto.tabelaPpm.modalEditarPpm.formulario.Moeda}:</label>
              <Select
                className="form-field-name"
                name="duplicate_currency_id"
                value={this.state.duplicate_currency_id}
                searchable={true}
                placeholder={''}
                onChange={this.handleSelectChange.bind(this, 'duplicate_currency_id')}
                options={this.state.currencies_select}
                required
              />
            </div>
            <div className="col-md-3 form-group">
              <label>{this.locale.OperadoresAeroporto.EditarOperadoresAeroporto.tabelaPpm.modalDuplicarPpm.formulario.Valor}:</label>
              <input type="text" placeholder="Valor" className="form-control" name="duplicate_value" value={this.state.duplicate_value} onChange={this.handleChange.bind(this, 'duplicate_value')} />
            </div>
          </div>
          <div>
              <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.OperadoresAeroporto.EditarOperadoresAeroporto.tabelaPpm.modalDuplicarPpm.formulario.botaoDuplicarPpm}</button>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal_duplicate: false })}>
        <i className="fa fa-fw fa-close"></i></button>
      </Modal.Footer>
    </Modal>
    <Modal show={this.state.modal_edit} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
      <Modal.Header>
        <h4 className="pull-left">{this.locale.OperadoresAeroporto.EditarOperadoresAeroporto.tabelaPpm.modalEditarPpm.titulo}</h4>
        <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal_edit: false })}>
        <i className="fa fa-fw fa-close"></i></button>
        <div className="clearfix"></div>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={this.edit}>
          <div className="row">
              <div className="col-md-6 form-group">
              <label>{this.locale.OperadoresAeroporto.EditarOperadoresAeroporto.tabelaPpm.modalEditarPpm.formulario.NaturezaDoVoo}:</label>
              <Select
                className="form-field-name"
                name="edit_domestic_flight"
                value={this.state.edit_domestic_flight}
                searchable={true}
                placeholder={''}
                onChange={this.handleSelectChange.bind(this, 'edit_domestic_flight')}
                options={[
                  {value: 1, label: this.locale.OperadoresAeroporto.EditarOperadoresAeroporto.tabelaPpm.modalEditarPpm.formulario.OpcoesNaturezaDoVoo.Domestico},
                  {value: 0, label: this.locale.OperadoresAeroporto.EditarOperadoresAeroporto.tabelaPpm.modalEditarPpm.formulario.OpcoesNaturezaDoVoo.Internacional},
                ]}
              />
              </div>
              <div className="col-md-6 form-group">
              <label>{this.locale.OperadoresAeroporto.EditarOperadoresAeroporto.tabelaPpm.modalEditarPpm.formulario.Grupo}:</label>
              <Select
                className="form-field-name"
                name="edit_group"
                value={this.state.edit_group}
                searchable={true}
                placeholder={''}
                onChange={this.handleSelectChange.bind(this, 'edit_group')}
                options={[
                {value: '1', label: '1'},
                {value: '2', label: '2'},
                {value: '3', label: '3'},
                ]}
              />
              </div>
          </div>
          <div className="row">
              <div className="col-md-6 form-group">
              <label>{this.locale.OperadoresAeroporto.EditarOperadoresAeroporto.tabelaPpm.modalEditarPpm.formulario.PmdDe}:</label>
              <input type="text" placeholder="" className="form-control" name="edit_pmd_from" value={this.state.edit_pmd_from} onChange={this.handleChange.bind(this, 'edit_pmd_from')} />
              </div>
              <div className="col-md-6 form-group">
              <label>{this.locale.OperadoresAeroporto.EditarOperadoresAeroporto.tabelaPpm.modalEditarPpm.formulario.PmdAte}:</label>
              <input type="text" placeholder="" className="form-control" name="edit_pmd_to" value={this.state.edit_pmd_to} onChange={this.handleChange.bind(this, 'edit_pmd_to')} />
              </div>
          </div>
          <div className="row">
              <div className="col-md-6 form-group">
              <label>{this.locale.OperadoresAeroporto.EditarOperadoresAeroporto.tabelaPpm.modalEditarPpm.formulario.DataDeInicioDeVigencia}:</label>
              <InputMask value={this.state.edit_date_start}  maskChar={null} name="edit_date_start " mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'edit_date_start')} placeholder="" required />
              </div>
              <div className="col-md-6 form-group">
              <label>{this.locale.OperadoresAeroporto.EditarOperadoresAeroporto.tabelaPpm.modalEditarPpm.formulario.DataDeTerminoDeVigencia}:</label>
              <InputMask value={this.state.edit_date_finish}  maskChar={null} name="edit_date_finish " mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'edit_date_finish')} placeholder="" required />
              </div>
          </div>
          <div className="row">
              <div className="col-md-6 form-group">
                <label>{this.locale.OperadoresAeroporto.EditarOperadoresAeroporto.tabelaPpm.modalEditarPpm.formulario.Moeda}:</label>
                <Select
                  className="form-field-name"
                  name="edit_currency_id"
                  value={this.state.edit_currency_id}
                  searchable={true}
                  placeholder={''}
                  onChange={this.handleSelectChange.bind(this, 'edit_currency_id')}
                  options={this.state.currencies_select}
                />
              </div>
              <div className="col-md-6 form-group">
                <label>{this.locale.OperadoresAeroporto.EditarOperadoresAeroporto.tabelaPpm.modalEditarPpm.formulario.Valor}:</label>
                <input type="text" placeholder="Valor" className="form-control" name="edit_value" value={this.state.edit_value} onChange={this.handleChange.bind(this, 'edit_value')} />
              </div>
          </div>
          <div>
              <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.OperadoresAeroporto.EditarOperadoresAeroporto.tabelaPpm.modalEditarPpm.formulario.botaoEditarPpm}</button>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal_edit: false })}>
        <i className="fa fa-fw fa-close"></i></button>
      </Modal.Footer>
    </Modal>
</div>
    );
  }
}

export default AirportOperatorsPpmAdd;



// WEBPACK FOOTER //
// ./src/Components/AirportOperators/Elements/AirportOperatorPpmAdd.js